import { state } from '../state'

/**
 * Handle search input with debounce functionality
 * @param {string} query - The search query
 * @param {Function} emitSearch - Function to emit the search event
 */
export const handleSearch = (query, emitSearch) => {
  // Don't re-emit the same search query
  if (query === state.lastSearchQuery.value) {
    return
  }

  // If we're in cooldown and the query is empty, don't emit
  if (state.searchCooldown.value && !query) {
    return
  }

  // Emit the search event
  emitSearch(query)
  
  // Update last search query
  state.lastSearchQuery.value = query
  
  // Set cooldown flag to prevent rapid re-searches
  state.searchCooldown.value = true

  // Reset cooldown after delay
  setTimeout(() => {
    state.searchCooldown.value = false
  }, 300) // Reduced from 5000ms for better UX
}

/**
 * Reset the search query
 * @param {Function} emitSearch - Function to emit the search event
 */
export const resetSearch = (emitSearch) => {
  state.lastSearchQuery.value = ''
  emitSearch('')
}
